export default __webpack_public_path__ + "static/media/3.19cfb969.jpg";